import React, { useState, useEffect } from "react";
import { sendCode, verifyCode } from "../../services/loginService";
import { useNavigate } from "react-router-dom";

const ForgotPasswordEmail = () => {
  const [step, setStep] = useState("email"); // 'email' | 'code'
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [timer, setTimer] = useState(60);
  const [canResend, setCanResend] = useState(false);
  const navigate = useNavigate();

  let data = {};
  data.email = email;

  const sendPasscode = (e) => {
    e.preventDefault();
    sendCode(data)
      .then((response) => {
        let message = response.data;
      })
      .catch((err) => {
        console.log(err);
      });
    console.log("Sending passcode to:", email);
    setStep("code");
    setTimer(60);
    setCanResend(false);
  };

  const handleResend = () => {
    if (!canResend) return;
    console.log("Resending code to:", email);
    setTimer(60);
    setCanResend(false);
  };

  let codeData = {};
  codeData.email = email;
  codeData.code = code;

  const params = new URLSearchParams();
  params.append("email", data.email);

  const handleVerifyCode = (e) => {
    e.preventDefault();
    if (code.length === 6) {
      console.log("Verifying code:", code);
      verifyCode(codeData)
        .then((response) => {
          console.log(response.data);
          if (response.data.message === "Code Successful") {
            navigate(`/setpassword?${params.toString()}`);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      alert("Enter the 6-digit passcode.");
    }
  };

  // Timer logic
  useEffect(() => {
    if (step === "code" && timer > 0) {
      const countdown = setTimeout(() => setTimer(timer - 1), 1000);
      return () => clearTimeout(countdown);
    } else if (step === "code") {
      setCanResend(true);
    }
  }, [timer, step]);

  return (
    <div className="flex min-h-full flex-1">
      <div className="flex flex-1 flex-col justify-center px-4 py-12 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
        <div className="mx-auto w-full max-w-sm lg:w-96">
          <h1 className="mt-8 text-2xl/9 font-bold tracking-tight text-gray-900">
            BlogSlicer
          </h1>

          {step === "email" && (
            <>
              <h2 className="mt-2 text-sm/6 text-gray-500">
                Enter your email address to reset password
              </h2>

              <form
                method="POST"
                className="space-y-6 mt-10"
                onSubmit={sendPasscode}
              >
                <div>
                  <label
                    htmlFor="email"
                    className="block text-sm/6 font-medium text-gray-900"
                  >
                    Email address
                  </label>
                  <div className="mt-2">
                    <input
                      type="email"
                      id="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                    />
                  </div>
                </div>

                <button
                  type="submit"
                  className="w-full bg-indigo-600 text-white font-semibold px-3 py-1.5 rounded-md hover:bg-indigo-500"
                >
                  Submit
                </button>
              </form>
            </>
          )}

          {step === "code" && (
            <>
              <h2 className="mt-6 text-sm/6 text-gray-500">
                Enter the 6-digit code sent to {email}
              </h2>

              <form onSubmit={handleVerifyCode} className="space-y-6 mt-8">
                <input
                  type="text"
                  maxLength="6"
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  className="w-full text-center tracking-widest text-xl px-3 py-2 border rounded-md"
                  placeholder="••••••"
                />

                <button
                  type="submit"
                  className="w-full bg-indigo-600 text-white font-semibold px-3 py-1.5 rounded-md hover:bg-indigo-500"
                >
                  Verify Code
                </button>

                <div className="text-center text-sm text-gray-600">
                  {canResend ? (
                    <button
                      type="button"
                      className="text-indigo-600 underline"
                      onClick={handleResend}
                    >
                      Resend Code
                    </button>
                  ) : (
                    <>Resend available in {timer}s</>
                  )}
                </div>
              </form>
            </>
          )}
        </div>
      </div>

      <div className="relative hidden w-0 flex-1 lg:block min-h-[720px]">
        <img
          alt=""
          src="https://images.unsplash.com/photo-1496917756835-20cb06e75b4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1908&q=80"
          className="absolute inset-0 size-full object-cover"
        />
      </div>
    </div>
  );
};

export default ForgotPasswordEmail;
